import React from 'react';
import PropTypes from 'prop-types';

import {Stack} from 'views/components';
import {Translate} from 'views/module';

import _ from 'lodash';

const CaregiverRemoveContact = (props) => {
  const {
    oldData,
    newData,
  } = props;

  const oldContact = oldData.contacts;
  const newContact = newData.contacts;

  const getDifference = React.useCallback(() => {
    const diffKeys = [];

    // Get all unique keys from both objects
    const allKeys = new Set([...Object.keys(oldContact), ...Object.keys(newContact)]);

    // Iterate over each key and check for differences
    allKeys.forEach((key) => {
      if (!_.isEqual(oldContact[key], newContact[key])) {
        diffKeys.push(oldContact[key]);
      }
    });

    return diffKeys;
  }, [oldContact, newContact]);

  const difference = getDifference();

  return (
    <Stack>
      {
        difference.map((e, index) => {
          return (
            <Translate
              key={index}
              expression='caregiver.CaregiverDetail.Correspondance.Logs.RemoveContact.Text'
              substitute={{type: e.type, detail: e.detail}}
            />
          );
        })
      }
    </Stack>
  );
};
CaregiverRemoveContact.propTypes = {
  oldData: PropTypes.object.isRequired,
  newData: PropTypes.object.isRequired,
};

export default React.memo(CaregiverRemoveContact);
